import { create } from 'zustand';

export enum STEP {
  PHONE_NUMBER = 'phone-number',
  OTP = 'OTP',
  PLATE = 'PLATE',
}

interface OTPAuthStore {
  step: STEP;
  show: boolean;
  paymentTime: Date | null;
  mobilePhone: string;
  callBack: (isFailed?: boolean, user?: any) => void | null;
  reset: () => void;
  setMobilePhone: (mobilePhone: string) => void;
  setPaymentTime: (paymentTime: Date | null) => void;
  setShow: (show: boolean, callBack?: (isFailed?: boolean) => void) => void;
  setStep: (step: STEP) => void;
  resendWaiting: boolean;
}

const useOTPAuthStore = create<OTPAuthStore>((set) => ({
  step: STEP.PHONE_NUMBER,
  show: false,
  paymentTime: null,
  mobilePhone: '',
  resendWaiting: false,
  callBack: () => null,
  reset: () =>
    set({
      mobilePhone: '',
      callBack: undefined,
      show: false,
      step: STEP.PHONE_NUMBER,
      resendWaiting: false,
    }),
  setMobilePhone: (mobilePhone) => set({ mobilePhone }),
  setPaymentTime: (paymentTime) => set({ paymentTime }),
  setShow: (show, callBack) => set({ show, callBack: callBack || undefined }),
  setStep: (step) => set({ step }),
}));
export default useOTPAuthStore;
